import { isEmpty } from 'lodash'

export const isSubscribed = subscription => subscription?.displayName?.toUpperCase() === 'PLUS'

export const isSubscriptionCanceled = subscription => !isEmpty(subscription?.endDate)
